import EventManager from "../canvas/store/sqftEventManager";
import workspace from "../canvas/core/workspace";
import config from "../canvas/store/sqftConfig";
import MiteredController from "../canvas/core/controls/mitered";
import FreeDraw from "../canvas/core/controls/freeDraw";
import UnderlaymentController from "../canvas/core/controls/underlayment";

export const resetEvents = function () {
  EventManager.stealCursor(true);
  EventManager.resetCursor(self);
  workspace.setAllowEdges(false);
  workspace.setAllowBumpoutEdges(false);
};

export const handleResizeClick = function () {
  EventManager.stealCursor(true);
  EventManager.resetCursor(this);
  workspace.setAllowEdges(true);
  workspace.setAllowLineHighlight(true);
  setTimeout(function () {
    workspace.setAllowLineHighlight(false)
  }, 1000)
};

export const handleSpacerClick = function () {
  // EventManager.stealCursor(true);
  // EventManager.resetCursor(this);
  // workspace.setAllowEdges(true);
  // workspace.setAllowLineHighlight(true);
  // setTimeout(function () {
  //   workspace.setAllowLineHighlight(false)
  // }, 1000)
};

export const handleRotateClick = function () {
  //EventManager.stealCursor(true);
  //EventManager.setCursor("rotate-left", this, true);
  EventManager.stealCursor(true);
  config.workspace.menuItemActive = "rotate-left";
};

export const handleWallClick = function () {
  EventManager.stealCursor(true);
  config.workspace.menuItemActive = "wall";
  FreeDraw.init();
};

export const handleDuplicateClick = function () {
  EventManager.stealCursor(true);
  EventManager.setCursor("duplicate", this, true);
  config.workspace.menuItemActive = "duplicate";
};

export const handleAngleClick = function () {
  EventManager.stealCursor(true);
  EventManager.resetCursor(self);
  config.highlight.rotateAngle = true;
  workspace.getShapes().forEach((shape) => {
    if (Array.isArray(shape.rotateAngleParts) && shape.rotateAngleParts.length) {
      // todo fix bumpout rotation and remove this
      if (shape.isWithBumpout()) return;
      /////////////////////////////////////////
      shape.activateRotateAngle();
    }
  });
};

export const handleTextClick = function () {
};

export const handleResetClick = function () {
  EventManager.stealCursor(true);
  EventManager.resetCursor(self);
};

//todo sqft-react
export const handleMiteredClick = () => {
  EventManager.stealCursor(true);
  EventManager.resetCursor(self);

  // let cursor = new Cursor();
  // cursor.setCursorImage('./images/cursors/plus_blue.png');

  if (workspace.miteredController === null) {
    workspace.miteredController = new MiteredController();
  }
  workspace.miteredController.createCursor();
  workspace.miteredController.registerEvents();

  workspace.setAllowMiteredEdges(true);
  workspace.setAllowLineHighlight(true);

  //Bumpout.addBumpout_onClick();
  setTimeout(function () {
    workspace.setAllowLineHighlight(false)
  }, 1000)
}

//todo sqft-react
export const handleUnderlaymentClick = () => {
  EventManager.stealCursor(true);
  EventManager.resetCursor();

  // let cursor = new Cursor();
  // cursor.setCursorImage('./images/cursors/plus_blue.png');

  if (workspace.underlaymentController === null) {
    workspace.underlaymentController = new UnderlaymentController();
  }
  workspace.underlaymentController.createCursor();
  workspace.underlaymentController.registerEvents();

  workspace.setAllowMiteredEdges(true);
  workspace.setAllowLineHighlight(true);

  //Bumpout.addBumpout_onClick();
  setTimeout(function () {
    workspace.setAllowLineHighlight(false)
  }, 1000)
}
